export const languageElements = {
  items: {
    "warehouse-stocks-title": {
      hu: "Készlet információ",
      de: "Bestände",
      en: "Stocks",
    },

    "warehouse-stocks-descr": {
      hu: "Excel-be exportálható készletlista",
      de: "Bestandsliste mit Excel Export",
      en: "List of stocks, export data to Excel",
    },

    "warehouse-journal-title": {
      hu: "Mozgásnapló",
      de: "Bewegungsliste",
      en: "List of movements",
    },

    "warehouse-journal-descr": {
      hu: "Excel-be exportálható mozgáslista",
      de: "Liste der Bewegungen, exportierbar nach Excel",
      en: "List of movements, exportable to Excel",
    },
  },
};
